import React from 'react'
import PrivacyPolicyComponent from '../components/PrivacyPolicyComponent';
import { termsAndConditionsData } from '../mock/mockData';

const ExternalTandC = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
            <PrivacyPolicyComponent 
                title="Terms and Conditions" 
                lastUpdated="10th December, 2025"
                contentData={termsAndConditionsData} 
            />
        </div>
      </div>
    </div>
  )
}

export default ExternalTandC;